import { useState } from "react";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import Confirm from "../../components/Confirm";
import Button from "../../components/Button";
import "./index.scss";
import { addSchedule, getEventScheduled } from "../../api/schedule";
import { Form, Row, InputForm, Validation, DateTimePickerCustom } from "../../components/Form";

const validation = {
  location: Validation.required,
  // verifyDatetimeFormat also requires a value.
  scheduleTrainingStartDate: Validation.verifyDatetimeFormat,
  scheduleTrainingEndDate: Validation.verifyDatetimeFormat,
};

const ScheduleAdd = ({ match, history }) => {
  const { t } = useTranslation();
  const [isModalShow, setIsModalShow] = useState(false);

  async function addScheduleForm(data) {
    if (data.scheduleTrainingStartDate > data.scheduleTrainingEndDate) {
      setIsModalShow(true);
    } else {
      data.courseTrainingId = match.params.trainingId;
      data.eventType = match.params.eventType;

      if (match.params.userId === "all") {
        const usersAbleToPractical = await getEventScheduled(match.params.eventType, match.params.trainingId);
        data.userIds = usersAbleToPractical.filter((el) => !el.start_date && !el.end_date).map((i) => i.user_id);
      } else {
        data.userIds = [match.params.userId];
      }

      const result = await addSchedule(data);
      if (result.ok) {
        history.push(`/trainings/schedule/${match.params.eventType}/${match.params.trainingId}`);
      }
    }
  }

  function confirmModal() {
    setIsModalShow(false);
  }

  return (
    <>
      <h2>{t("schedule.add_slot_title")}</h2>
      <Paper variant="outlined" style={{ padding: "1rem 1.5rem" }}>
        <Form onSubmit={addScheduleForm} validation={validation}>
          <Row>
            <InputForm label={`${t("location")}*`} name="location" />
          </Row>
          <Row>
            <DateTimePickerCustom label={t("start_date")} name="scheduleTrainingStartDate" />
          </Row>
          <Row>
            <DateTimePickerCustom label={t("end_date")} name="scheduleTrainingEndDate" />
          </Row>
          <Button type="submit" title={t("add")}>
            {t("add")}
          </Button>
          <Button title={t("navigate_back")} type="button" onClick={() => history.goBack()}>
            {t("cancel")}
          </Button>
        </Form>
      </Paper>
      {isModalShow && (
        <Confirm title={t("schedule.check_date_interval")} notification={true} onConfirm={confirmModal}>
          <p>{t("schedule.end_date_greater_than_start")}</p>
        </Confirm>
      )}
    </>
  );
};

export default ScheduleAdd;
